import { ActionPageTypes } from "shared/pages/ActionsPage";

import { IState } from "..";
import { AnalyticsEvent } from "../../../services/Analytics/AnalyticsConstants";
import MixPanelAnalyticsService from "../../../services/Analytics/MixPanelAnalyticsService";
import FirebaseFunctionsService from "../../../services/firebase/functions/FirebaseFunctionsService";
import RavenService from "../../../services/Logging/RavenService";
import { Dispatch } from "../../store/store";
import { IActionParams } from "./ActionsModule";

export const postApplicationAction = async (
  params: IActionParams,
  state: IState
) => {
  try {
    const { actionType, coworkName, id: id } = params;
    Dispatch.actions.postingAction({ action: actionType });

    if (!id || !actionType) {
      throw new Error(`Missing params ${JSON.stringify(params)}`);
    }

    await runAction(params);

    Dispatch.actions.actionSucceeded();
    if (actionType === ActionPageTypes.UnsubscribeLead) {
      MixPanelAnalyticsService.track(AnalyticsEvent.UnsubscribeLead, {
        memberId: id,
        actionType
      });
    }
    else {
      MixPanelAnalyticsService.track(AnalyticsEvent.ApplicationAction, {
        applicationId: id,
        coworkName: coworkName || "NA",
        actionType
      });
    }
  } catch (err) {
    const errorMessage = `Failed running action ${err} with ${JSON.stringify(
      params
    )}`;
    const error: Error = err;
    Dispatch.actions.actionFailed(error.message);
    RavenService.captureMessage(errorMessage);
  }
};

const runAction = async (params : IActionParams) => {
  const actionType = params.actionType
  switch (actionType) {
    case ActionPageTypes.DeclineMember:
      return setMemberVerification(false, params);
    case ActionPageTypes.VerifyMember:
      return setMemberVerification(true, params);
    case ActionPageTypes.UnsubscribeLead:
      return unsubscribeLeadFromFollowups(params);
    default:
      throw Error("Unknown action");
  }
};

const setMemberVerification = async (
  verified: boolean,
  { coworkName, id: applicationId }: IActionParams
) => {
  const params = { verified, applicationId, coworkName };
  const response = await FirebaseFunctionsService.updateMemberVerification(
    params
  );

  if (!response.ok) {
    throw new Error(response.message || "Failed verifying member");
  }
};

const unsubscribeLeadFromFollowups = async (params : IActionParams) => {
  const memberId = params.id
  const response = 
  await FirebaseFunctionsService.unsubscribeLeadFromFollowups(memberId);

  if (!response.ok) {
    throw new Error(response.message || "Failed verifying member");
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/actions/ActionsEffects.ts